export default __webpack_public_path__ + "fonts/demographics_owners_renters_icon.svg";